import solicitudes from './solicitudes.js';

export const obtenerCuentasPorCobrar = async (id_usuario, sucursal = null) => {
    try {
        const qs = sucursal ? `?sucursal=${sucursal}` : '';
        const cuentas = await solicitudes.fetchRegistrosAuth(`/cuentas-por-cobrar/${id_usuario}${qs}`);
        return cuentas;
    } catch (error) {
        console.error('Error al obtener cuentas por cobrar:', error);
        throw new Error('No se pudieron obtener las cuentas por cobrar.');
    }
};

export const obtenerCuentasPorCobrarPorSucursal = (id_sucursal) =>
    solicitudes.fetchRegistrosAuth(`/cuentas-por-cobrar/sucursal/${id_sucursal}`);

export const obtenerFacturasPendientesPorCliente = async (id_cliente, id_usuario) => {
    console.log('🔧 =================================');
    console.log('🔧 SERVICE: obtenerFacturasPendientesPorCliente');
    console.log('🔧 id_cliente recibido:', id_cliente);
    console.log('🔧 id_usuario recibido:', id_usuario);
    console.log('🔧 =================================');
    
    try {
        const url = `/cuentas-por-cobrar/facturas/${id_cliente}/${id_usuario}`;
        console.log('🌐 URL construida:', url);
        
        const facturas = await solicitudes.fetchRegistrosAuth(url);
        
        console.log('✅ Respuesta de fetchRegistrosAuth:', facturas);
        console.log('📊 Length:', facturas?.length);
        
        return facturas;
    } catch (error) {
        console.error('💥 Error en service obtenerFacturasPendientesPorCliente:', error);
        throw new Error('No se pudieron obtener las facturas pendientes del cliente.');
    }
};

export const registrarPagoCredito = async (datosPago, id_usuario) => {
    try {
        const response = await solicitudes.postRegistroAuth(`/cuentas-por-cobrar/pagar/${id_usuario}`, datosPago);
        return response;
    } catch (error) {
        console.error('Error al registrar pago:', error);
        throw new Error('No se pudo registrar el pago.');
    }
};

export const obtenerHistorialPagos = async (id_cliente, id_usuario) => {
    try {
        const url = `/cuentas-por-cobrar/historial/${id_cliente}/${id_usuario}`;
        const historial = await solicitudes.fetchRegistrosAuth(url);
        return historial;
    } catch (error) {
        console.error('💥 Error en service obtenerHistorialPagos:', error);
        throw new Error('No se pudo obtener el historial de pagos.');
    }
};

// ⚠️ CORRECCIÓN PRINCIPAL: Cambiar el método de generación de PDF
export const generarComprobantePago = async (id_cliente, id_usuario) => {
    console.log('🧾 =================================');
    console.log('🧾 SERVICE: generarComprobantePago');
    console.log('🧾 id_cliente recibido:', id_cliente);
    console.log('🧾 id_usuario recibido:', id_usuario);
    console.log('🧾 =================================');
    
    try {
        const url = `${solicitudes.homeUrl}/cuentas-por-cobrar/comprobante/${id_cliente}/${id_usuario}`;
        console.log('🌐 URL completa:', url);

        const token = localStorage.getItem("auth");
        if (!token) {
            throw new Error('No hay token de autenticación');
        }

        console.log('📡 Realizando petición para PDF...');
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });

        console.log('📋 Response status:', response.status);
        console.log('📋 Response headers:', response.headers);

        if (!response.ok) {
            const errorText = await response.text();
            console.error('❌ Error response:', errorText);
            throw new Error(`Error del servidor: ${response.status} ${response.statusText}`);
        }

        // Verificar que la respuesta sea realmente un PDF
        const contentType = response.headers.get('content-type');
        console.log('📄 Content-Type:', contentType);
        
        if (!contentType || !contentType.includes('application/pdf')) {
            console.error('❌ La respuesta no es un PDF, content-type:', contentType);
            throw new Error('La respuesta del servidor no es un PDF válido');
        }

        console.log('📄 Obteniendo blob...');
        const blob = await response.blob();
        console.log('📄 Blob size:', blob.size);

        if (blob.size === 0) {
            throw new Error('El PDF generado está vacío');
        }

        console.log('💾 Creando URL del blob...');
        const url_blob = window.URL.createObjectURL(blob);

        console.log('⬇️ Configurando descarga...');
        const a = document.createElement("a");
        a.href = url_blob;
        a.download = `comprobante_pago_${id_cliente}_${Date.now()}.pdf`;

        console.log('🚀 Iniciando descarga...');
        document.body.appendChild(a);
        a.click();

        console.log('🧹 Limpiando recursos...');
        window.URL.revokeObjectURL(url_blob);
        document.body.removeChild(a);

        console.log('✅ Comprobante descargado exitosamente');
        return { success: true, message: 'Comprobante generado exitosamente' };
        
    } catch (error) {
        console.error('💥 Error al generar comprobante:', error);
        throw new Error(`No se pudo generar el comprobante de pago: ${error.message}`);
    }
};

export const obtenerReporteCreditos = async (id_usuario, filtros = {}) => {
    try {
        const params = new URLSearchParams(filtros).toString();
        const url = `/cuentas-por-cobrar/reporte/${id_usuario}${params ? `?${params}` : ''}`;
        const reporte = await solicitudes.fetchRegistrosAuth(url);
        return reporte;
    } catch (error) {
        console.error('Error al obtener reporte de créditos:', error);
        throw new Error('No se pudo obtener el reporte de créditos.');
    }
};

export default {
    obtenerCuentasPorCobrar,
    obtenerCuentasPorCobrarPorSucursal,
    obtenerFacturasPendientesPorCliente,
    registrarPagoCredito,
    obtenerHistorialPagos,
    generarComprobantePago,
    obtenerReporteCreditos
};